// This file uses the Modernizr functionality exposed in through modernizr-custom.js 
// modernizr-custom.js is created online at https://modernizr.com/ by selecting the minimal set of 
// feature detection test that our product needs. 
// For example, we currently use 
// https://modernizr.com/download/?-canvas-canvastext-localstorage-sessionstorage-touchevents-setclasses
// 
// The resulting js file output comes minified. We usually pass it through an online tool to beautify it and 
// then replace the full contents of modernizr-custom.js.
//
    
    
function getMissingFeatures () {
    var features = '<h3>HTML5:</h3>';
    var count = 0;

    if (!Modernizr.canvas) {
        features += '<p>Canvas</p>';
        count++;
    }
    if (!Modernizr.canvastext) {
        features += '<p>Canvas Text</p>';
        count++;
    }
    if (!Modernizr.localstorage) {
        features += '<p>Local Storage</p>';
        count++;
    }
    if (!Modernizr.sessionstorage) {
        features += '<p>Session Storage</p>';
        count++;
    }
    return {
        features: features,
        count: count
    };

}
function isTouchEnabled() {
    return Modernizr.touchevents; 
}

var missingFeatures = getMissingFeatures();
